export default "__VITE_ASSET__zCnbrpkQ__"